<script setup>
import { Info, CircleCheckBig, AlertCircle, Quote, Type } from "lucide-vue-next";
import { Tooltip } from "@/components/ui/tooltip";

const STYLE_OPTIONS = [
  { value: "info", label: "Info", icon: Info, activeClass: "text-status-info" },
  { value: "success", label: "Success", icon: CircleCheckBig, activeClass: "text-status-success-strong" },
  { value: "warning", label: "Warning", icon: AlertCircle, activeClass: "text-status-warning" },
  { value: "quote", label: "Quote", icon: Quote, activeClass: "text-muted-foreground" },
  { value: "none", label: "None", icon: Type, activeClass: "text-muted-foreground" },
];

const modelValue = defineModel({ type: String, default: "info" });
</script>

<template>
  <div class="flex gap-0.5">
    <Tooltip
      v-for="opt in STYLE_OPTIONS"
      :key="opt.value"
      :content="opt.label">
      <button
        :aria-label="'Set style to ' + opt.label"
        class="h-7 w-7 inline-flex items-center justify-center rounded transition-colors"
        :class="modelValue === opt.value
          ? 'bg-muted text-foreground'
          : 'text-muted-foreground hover:text-foreground'"
        @click="modelValue = opt.value">
        <component
          :is="opt.icon"
          class="h-3.5 w-3.5"
          :class="modelValue === opt.value ? opt.activeClass : ''" />
      </button>
    </Tooltip>
  </div>
</template>
